/* Copyright (c) 2021-2024 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ReactNode } from "react";
import { SVGIconProps } from "@nordcloud/gnui";

export type PathName = SVGIconProps["name"];

export type DeleteItem = {
  id: string;
  name: string;
};

export type Option = {
  label: string;
  value: string;
};

export type ControlsEvent = {
  search: string;
};

export type Maybe<T> = T | null | undefined;

export type NonPrimitiveProperties<T> = {
  [K in keyof T]: T[K] extends Record<string, unknown> ? T[K] : never;
};

export type DeepReadOnly<T> = { readonly [K in keyof T]: DeepReadOnly<T[K]> };

export function getTypedKeys<T extends Record<string, unknown>>(object: T): (keyof T)[] {
  return Object.keys(object) as (keyof typeof object)[];
}

export type WithChildren<T = Record<string, unknown>> = T & {
  children?: ReactNode;
};

export function isPrimitive(value: unknown): value is Record<string, unknown> {
  return ["number", "boolean", "string", "bigint", "null", "undefined", "symbol"].includes(typeof value);
}

export function isNotPrimitive(value: unknown): value is Record<string, unknown> {
  return !isPrimitive(value);
}

export enum ProductType {
  MulticloudAccelerator = "MulticloudAccelerator",
  MachineImageToolkit = "MachineImageToolkit",
  MulticloudAutoPatcher = "MulticloudAutoPatcher",
}

export type AsStoreObject<
  T extends {
    __typename?: string;
  },
> = {
  [K in keyof T]: T[K];
};
